// Thin client for the Edge Function dispatcher at /functions/v1/api.
// Every call includes Telegram initData for auth — verified per-request on the server.

import { initData } from "./tg";

const URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/api`;
const ANON = import.meta.env.VITE_SUPABASE_ANON_KEY;

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function call<T = unknown>(action: string, params?: Record<string, unknown>): Promise<T> {
  const init = initData();
  if (!init) throw new ApiError("Open via Telegram client", 0);

  let r: Response;
  try {
    r = await fetch(URL, {
      method: "POST",
      headers: { "content-type": "application/json", apikey: ANON },
      body: JSON.stringify({ initData: init, action, params }),
    });
  } catch (e) {
    throw new ApiError(`Network error: ${(e as Error).message}`, 0);
  }

  let body: { ok?: boolean; data?: T; error?: string };
  try { body = await r.json(); } catch { body = { ok: false, error: `HTTP ${r.status}` }; }

  if (!body.ok) throw new ApiError(body.error ?? `HTTP ${r.status}`, r.status);
  return body.data as T;
}
